import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M15.335 4.292c0 1.802-2.35 4.042-3.521 4.981a1.033 1.033 0 0 1-1.292 0c-1.17-.94-3.521-3.179-3.521-4.981A2.195 2.195 0 0 1 9.084 2a2.195 2.195 0 0 1 2.084 2.292A2.195 2.195 0 0 1 13.252 2a2.195 2.195 0 0 1 2.083 2.292Zm6.116 8-6.417 7.007A8.336 8.336 0 0 1 8.886 22H5.334A3.334 3.334 0 0 1 2 18.667V14.5a3.333 3.333 0 0 1 3.334-3.333h6.49a1.848 1.848 0 0 1 1.803 2.237 1.899 1.899 0 0 1-1.616 1.444l-3.47.485a.834.834 0 0 0 .236 1.65l3.544-.5a3.529 3.529 0 0 0 3.014-3.472 3.4 3.4 0 0 0-.054-.532l2.952-3.114a2.172 2.172 0 0 1 3.764 1.363 2.18 2.18 0 0 1-.546 1.56v.004Z" }, null, -1)
  ])))
}
export default { render: render }